import { LitElement, html, css, unsafeCSS } from "lit-element";
import Consts from "../../../consts/consts";
import { MetricMatchModel } from "../../../models/broadcast/metricMatchModel";

import broadcastLiveStatsHeaderStyles from "./broadcast-live-stats-header.scss";


export default class BroadcastLiveStatsHeader extends LitElement {
    private _match: MetricMatchModel;
    private _homeTeamColour: string;
    private _awayTeamColour: string;

    constructor(
        match: MetricMatchModel,
        homeTeamColour: string,
        awayTeamColour: string) {
        super();

        this._match = match;

        this._homeTeamColour = homeTeamColour;
        this._awayTeamColour = awayTeamColour;
    }

    async firstUpdated() {
        this.style.setProperty("--home-color", this._homeTeamColour);
        this.style.setProperty("--away-color", this._awayTeamColour);
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return html`
            <style>
                 ${css`${unsafeCSS(broadcastLiveStatsHeaderStyles)}`}                     
             </style>
             
        <div class="header-container">
            <div class="teams-container">
                <div class="team-container home-team">      
                    <div class="team-bubble">&nbsp;</div>           
                        <h3>${this._match.teams[0].name}</h3>    
                        <div class="home-team-logo">
                            <img src="https://mobiithumbnails.azureedge.net/thumbnails/live/stratus/${this._match.teams[0].teamId}/small.png" />
                        </div>       

                        <h3 class="score">${this._match.teams[0].score ?? 0}</h3>
                </div>

                <h3 class="score">-</h3>

                <div class="team-container away-team">        
                    <h3 class="score">${this._match.teams[1].score ?? 0}</h3>  

                    <div class="away-team-logo">
                        <img src="https://mobiithumbnails.azureedge.net/thumbnails/live/stratus/${this._match.teams[1].teamId}/small.png" />
                    </div>                
                    <h3>${this._match.teams[1].name}</h3>        
                    <div class="team-bubble">&nbsp;</div>            
                </div>
            </div>
            <div class="time-container">
                ${this._match.metrics.find(x => x.metricId == Consts.ClockTimeMetricId)?.timeString}
            </div>
        </div>`;
    }
}

window.customElements.define('broadcast-live-stats-header', BroadcastLiveStatsHeader as any);